module.exports = __webpack_public_path__ + "san-francisco-text-regular.428b71ceb9bb84df6210.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/san-francisco-text-regular.eot
// module id = 372
// module chunks = 32